import { Box, Button, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { NavigateAction, ToolbarProps, View } from "react-big-calendar";

import AppIcon from "../Icons/AppIcon";

const NAV_BUTTONS: { label: string; action: NavigateAction; icon: React.ReactNode }[] = [
  { label: "Back", action: "PREV", icon: <AppIcon of='arrowBack' /> },
  { label: "Today", action: "TODAY", icon: <AppIcon of='date' /> },
  { label: "Next", action: "NEXT", icon: <AppIcon of='arrowForward' /> },
];

const InactiveButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.divider,
  boxShadow: "2px 2px 10px 0 rgba(7, 23, 61, 0.1)",
}));

export default function CalendarToolbar<TEvent extends object = object>({
  label,
  onNavigate,
  onView,
  views,
  view,
}: ToolbarProps<TEvent>) {
  const viewNames: string[] = Array.isArray(views) ? (views as string[]) : Object.keys(views);

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ mb: 2 }}>
      {/* Navigation Buttons */}
      <Stack direction='row' alignItems='center' gap={1} flexWrap={"wrap"}>
        {NAV_BUTTONS.map((btn) => (
          <InactiveButton
            key={btn.action}
            variant='outlined'
            color='text'
            onClick={() => onNavigate(btn.action)}
            startIcon={btn.icon}
          >
            {btn.label}
          </InactiveButton>
        ))}
      </Stack>

      {/* Label (current period) */}
      <Box sx={{ fontWeight: 600, fontSize: 18 }}>{label}</Box>

      {/* View Buttons */}
      <Stack direction='row' alignItems='center' gap={1} flexWrap={"wrap"}>
        {viewNames.map((v: string) =>
          view === v ? (
            <Button
              key={v}
              variant='contained'
              color='text'
              onClick={() => onView(v as View)}
              sx={{ textTransform: "capitalize" }}
            >
              {v.replace(/_/g, " ")}
            </Button>
          ) : (
            <InactiveButton
              key={v}
              variant='outlined'
              color='text'
              onClick={() => onView(v as View)}
              sx={{ textTransform: "capitalize" }}
            >
              {v.replace(/_/g, " ")}
            </InactiveButton>
          ),
        )}
      </Stack>
    </Stack>
  );
}
